import React, {Component} from 'react';
import {Layout} from 'antd';
import ProfilePic from '../../creatives/home/ProfilePic';

const {Content, Sider} = Layout;

class BrandHome extends Component {
    render(){
        return(
          
          <Layout style={{width: '100vw', height: '100vh'}}>
          <Sider style={{background: 'black'}} breakpoint='lg'>
            <ProfilePic />
          </Sider>
            <Content>
              
            </Content>
          <Sider style={{background: 'black'}}></Sider>
          </Layout>
        )
    }
}

export default BrandHome;